import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  deleteMatchById,
  type DeleteMatchByIdParams,
  type DeleteMatchByIdResponse,
} from '@services/MatchesService';

export type UseDeleteMatchByIdParams = {
  mutationOptions?: SWRMutationConfiguration<
    DeleteMatchByIdResponse,
    unknown,
    string,
    DeleteMatchByIdParams,
    DeleteMatchByIdResponse
  >;
};

export const deleteMatchByIdMutationKey = 'delete-match-by-id';

export const useDeleteMatchById = ({
  mutationOptions,
}: UseDeleteMatchByIdParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    DeleteMatchByIdResponse,
    unknown,
    string,
    DeleteMatchByIdParams
  >(
    deleteMatchByIdMutationKey,
    (_url, { arg }) => deleteMatchById(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
